import { FC, ReactElement } from 'react'
import { BokaService } from './BokaService'
import { CustomWidgetType, StorefrontWidget } from 'ecosystem'
import { WidgetImplementation } from 'storefront-modules/widgets/registry/typings'

type CustomComponentWidgetHandlerProps = WidgetImplementation<StorefrontWidget<CustomWidgetType>>

type CustomComponentWidget = 'STENLUNDS_BOKA_SERVICE'

export const CustomWidgetIdHandler: FC<CustomComponentWidgetHandlerProps> = ({ widget }) => {
  const widgetFactory = () => {
    const widgetDict: Record<CustomComponentWidget, ReactElement> = {
      STENLUNDS_BOKA_SERVICE: <BokaService />
    }

    return widgetDict[widget.widget.widgetId as CustomComponentWidget] ?? null
  }

  return <>{widgetFactory()}</>
}
